var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWayPointMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 28,
    viewBox: "0 0 22 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1952 26.4203C13.079 25.282 15.2503 22.4192 17.2054 19.321C18.1822 17.7729 19.1177 16.1464 19.8122 14.6342C20.4921 13.1539 21 11.6608 21 10.4196C21 7.89907 19.9291 5.49638 18.0471 3.73579C16.1674 1.97731 13.6315 1 11 1C8.36855 1 5.83256 1.97731 3.95287 3.73579C2.07092 5.49639 1 7.89907 1 10.4196C1 11.6609 1.50802 13.154 2.18805 14.6343C2.88271 16.1464 3.81832 17.773 4.79534 19.3211C6.7505 22.419 8.92196 25.2815 9.80586 26.4199C9.9508 26.6068 10.1363 26.7529 10.343 26.8515C10.5496 26.9501 10.7748 27 11.0007 27C11.2266 27 11.4517 26.9501 11.6583 26.8515C11.865 26.753 12.0503 26.6069 12.1952 26.4203Z",
    fill: "#565656",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWayPointMarker);
export default __webpack_public_path__ + "static/media/wayPointMarker.17f0fa6649f1d80ead1a4a1791ad3544.svg";
export { ForwardRef as ReactComponent };